import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { DeleteOutlined } from "@material-ui/icons";
import {
  useCancelBookingButtonsBookingLazyQuery,
  useCancelBookingMutation
} from "@bonliva-crm/graphql";
import { useSnackbarsPipeline } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";
import { CancelBookingDialog } from "../../CancelBookingDialog/CancelBookingDialog";
import { themeObject } from "@theme";

type Props = {
  bookingId: string;
};

export function CancelBookingButton(props: Props) {
  const snack = useSnackbarsPipeline();
  const [showCancelDialog, setShowCancelDialog] = useState(false);

  const [checkCancellable, { data, loading: checkLoading }] =
    useCancelBookingButtonsBookingLazyQuery();

  const [cancelBooking, { loading: mutationLoading }] = useCancelBookingMutation({
    onCompleted: () => {
      snack.showSuccess(locale["Booking has been canceled"]);
      setShowCancelDialog(false);
    },
    onError: (e) => {
      snack.showError(e.message, "Cannot cancel booking");
      setShowCancelDialog(false);
    }
  });

  const handleClick = () => {
    setShowCancelDialog(true);
    checkCancellable({
      variables: { bookingId: props.bookingId },
      fetchPolicy: "network-only"
    });
  };

  const blockReasons: string[] = [];
  if (data) {
    if (data.bookingById.IsCanceled) {
      blockReasons.push("Denna bokning är redan avbokad.");
    } else if (data.checkBookingCancellable.length > 0) {
      data.checkBookingCancellable.unique().forEach((reason) => {
        blockReasons.push(locale.bookingCannotBeRemovedReason[reason]);
      });
    }
  }

  const isCheckLoading = checkLoading || (showCancelDialog && !data);

  const warningTitle =
    data?.bookingById?.IsCustomerBilled && !isCheckLoading && blockReasons.length === 0
      ? "Det finns kundfakturor uppladdade på bokningsveckan, är du säker på att du vill avboka veckan?"
      : locale["Are you sure you want to cancel this booking?"];

  return (
    <>
      <Button
        variant="text"
        onClick={handleClick}
        style={{ color: themeObject.palette.error.main }}
      >
        <DeleteOutlined />
        {locale.CancelWeek}
      </Button>

      <CancelBookingDialog
        open={showCancelDialog}
        title={warningTitle}
        loading={mutationLoading}
        checkLoading={isCheckLoading}
        blockReasons={blockReasons.length > 0 ? blockReasons : undefined}
        onCancel={(reason) => {
          cancelBooking({
            variables: {
              id: props.bookingId,
              reason
            }
          });
        }}
        onClose={() => {
          setShowCancelDialog(false);
        }}
      />
    </>
  );
}
